module.exports = __webpack_public_path__ + "img/hold_qrcode.d091237d.png";